import MediaCenterLayout from '@/layout/MediaCenter/index';
export default [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/Pages/Home.vue')
    },
    {
        path: '/content/faq/hotfaq',
        name: 'TopFaq',
        component: () => import('@/views/Pages/TopFaq.vue')
    },
    {
        path: '/Orchard.Rccl.Users/Login/Login',
        name: 'Login',
        component: () => import('@/views/User/Login.vue')
    },
    {
        path: '/Orchard.Rccl.Users/Login/RecommendLogin',
        name: 'RecommendLogin',
        component: () => import('@/views/User/RecommendLogin.vue')
    },
    {
        path: '/Orchard.Rccl.Users/Auth/Index',
        name: 'UserCenter',
        component: () => import('@/views/Auth/Auth.vue')
    },
    {
        path: '/Orchard.Rccl.Users/Auth/Wechat',
        name: 'WechatAuth',
        component: () => import('@/views/Auth/WechatAuth.vue')
    },
    {
        path: '/Rccl.Cruise/CruiseSearch/Search',
        name: 'CruiseSearch',
        component: () => import('@/views/Cruise/Search.vue')
    },
    {
        path: '/Rccl.Cruise/CruiseDetail',
        name: 'CruiseDetail',
        props: true,
        component: () => import('@/views/Cruise/CruiseDetail.vue'),
    },
    {
        path: '/Rccl.Cruise/CruiseSearch/CruiseCalendar',
        name: 'CruiseCalendar',
        props: true,
        component: () => import('@/views/Cruise/CruiseCalendar.vue')
    },
    {
        path: '/Rccl.Booking/Booking/ShoppingCart',
        name: 'ShoppingCart',
        props: true,
        component: () => import('@/views/Booking/ShoppingCart.vue')
    },
    {
        path: '/Rccl.Booking/Booking/GuestInfo',
        name: 'GuestInfo',
        props: true,
        component: () => import('@/views/Booking/GuestInfo.vue')
    },
    {
        path: '/Rccl.Booking/Booking/PayByMethod',
        name: 'PayByMethod',
        props: true,
        component: () => import('@/views/Booking/PayByMethod.vue')
    },
    {
        path: '/Rccl.Booking/Booking/PaySuccess',
        name: 'PaySuccess',
        component: () => import('@/views/Booking/PaySuccess.vue')
    },
    {
        path: '/Rccl.Booking/Booking/PaySuccessBack',
        name: 'PaySuccessBack',
        props: true,
        component: () => import('@/views/Booking/PaySuccessBack.vue')
    },
    {
        path: '/Rccl.Booking/Booking/ChangeBookingContact',
        name: 'ChangeBookingContact',
        component: () => import('@/views/Booking/ChangeBookingContact.vue')
    },
    {
        path: '/Rccl.Booking/Booking/BookingSearch',
        name: 'BookingSearch',
        component: () => import('@/views/Booking/BookingSearch.vue')
    },
    {
        path: '/Rccl.Booking/Booking/BookingDetail',
        name: 'BookingDetail',
        component: () => import('@/views/Booking/BookingDetail.vue')
    },
    {
        path: '/Rccl.UserCenter/OrderRecord/List',
        name: 'BookingList',
        props: true,
        component: () => import('@/views/Booking/BookingList.vue')
    },
    {
        path: '/Rccl.Booking/OpenBooking/Detail',
        name: 'OpenBookingDetail',
        component: () => import('@/views/Booking/OpenBookingDetail.vue')
    },
    {
        path: '/Rccl.Booking/OpenBooking/PayByMethod',
        name: 'OpenBookingPayByMethod',
        props: true,
        component: () => import('@/views/Booking/OpenBookingPayByMethod.vue')
    },
    {
        path: '/Rccl.Booking/OpenBooking/Pay',
        name: 'OpenBookingPay',
        component: () => import('@/views/Booking/OpenBookingPay.vue')
    },
    {
        path: '/Rccl.Booking/Booking/OpenBookingPaySuccess',
        name: "OpenBookingPaySuccess",
        component: () => import('@/views/Booking/OpenBookingPaySuccess.vue')
    },
    {
        path: '/Rccl.UserCenter/CustomerInfo/SignUpReward',
        name: 'SignUpReward',
        component: () => import('@/views/User/SignUpReward.vue')
    },
    {
        path: '/Rccl.UserCenter/Cas',
        name: 'Cas',
        component: () => import('@/views/User/Cas.vue')
    },
    {
        path: '/Rccl.UserCenter/Cas/Index',
        redirect: {
            name: "Cas"
        }
    },
    {
        path: '/Rccl.UserCenter/CustomerInfo/BindLoyalty',
        name: 'BindLoyalty',
        component: () => import('@/views/User/BindLoyalty.vue')
    },
    {
        path: '/Rccl.UserCenter/CustomerInfo/CreateCas',
        name: 'CreateCas',
        component: () => import('@/views/User/CreateCas.vue')
    },
    {
        path: '/Rccl.Booking/Booking/Pay',
        name: 'Pay',
        props: true,
        component: () => import('@/views/Booking/Pay.vue')
    },
    {
        path: '/wzredyembark/wz_usual_question/index',
        redirect: { name: "Faq"}
    },
    {
        path: '/content/faq',
        name: 'Faq',
        component: () => import('@/views/Pages/Faq.vue')
    },
    {
        path: '/content/taste/ships/:shipCode',
        name: 'ShipDetail',
        component: () => import('@/views/Ships/ShipDetail.vue')
    },
    {
        path: '/wz_index_contract/index',
        name: 'Contract',
        component: () => import('@/views/Pages/Contract.vue')
    },
    {
        path: '/Rccl.UserCenter/Privacy',
        name: 'Privacy',
        component: () => import('@/views/Pages/Privacy.vue'),
        meta: {
            title: "隐私政策",
            hideHeaderAndFooter: true
        }
    },
    {
        path: '/Rccl.UserCenter/PrivacyMiniApp',
        name: 'PrivacyMiniApp',
        component: () => import('@/views/Pages/PrivacyMiniApp.vue'),
        meta: {
            title: "隐私政策",
            hideHeaderAndFooter: true
        }
    },
    {
        path: '/Rccl.UserCenter/RewardRule',
        name: 'RewardRule',
        component: () => import('@/views/Pages/RewardRule.vue'),
        meta: {
            title: "“皇家游享荟”项目细则与条款",
            hideHeaderAndFooter: true
        }
    },
    {
        path: '/Rccl.UserCenter/RewardRuleMiniApp',
        name: 'RewardRuleMiniApp',
        component: () => import('@/views/Pages/RewardRuleMiniApp.vue'),
        meta: {
            title: "“皇家游享荟”项目细则与条款",
            hideHeaderAndFooter: true
        }
    },
    {
        path: '/Rccl.UserCenter/HistoricalAgreementList',
        name: 'HistoricalAgreementList',
        meta: {
            title: "历史版本",
            hideHeaderAndFooter: true
        },
        component: () => import('@/views/Pages/HistoricalAgreementList.vue')
    },
    {
        path: '/Rccl.UserCenter/HistoricalAgreementDetails',
        name: 'HistoricalAgreementDetails',
        meta: {
            title: "",
            hideHeaderAndFooter: true
        },
        component: () => import('@/views/Pages/HistoricalAgreementDetails.vue')
    },
    {
        path: '/content/taste/taste',
        name: 'ShipExperiencePage',
        component: () => import('@/views/Ships/ShipExperiencePage.vue')
    },
    {
        path: '/Rccl.CustomPage/Ship',
        name: 'ShipIndex',
        component: () => import('@/views/Ships/ShipIndex.vue')
    },
    {
        path: '/Rccl.UserCenter/CustomerInfo/Info',
        name: 'UserCenterHome',
        component: () => import('@/views/UserCenter/UserCenter.vue')
    },
    {
        path: '/Rccl.UserCenter/CustomerInfo/EditInfo',
        name: 'EditInfo',
        component: () => import('@/views/UserCenter/EditInfo.vue')
    },
    {
        path: '/Rccl.UserCenter/UserCoupon/UserCoupon',
        name: 'UserCoupon',
        component: () => import('@/views/UserCenter/Coupon.vue')
    },
    {
        path: '/Rccl.UserCenter/WishList/List',
        name: 'WishList',
        component: () => import('@/views/UserCenter/WishList.vue')
    },
    {
        path: '/Rccl.UserCenter/UserContact/List',
        name: 'ContactList',
        component: () => import('@/views/UserCenter/ContactList.vue')
    },
    {
        path: '/Rccl.UserCenter/UserContact/Create',
        name: 'ContactCreate',
        component: () => import('@/views/UserCenter/ContactCreate.vue')
    },
    {
        path: '/Rccl.UserCenter/UserContact/Detail/:id',
        name: 'ContactDetail',
        component: () => import('@/views/UserCenter/ContactDetail.vue')
    },
    {
        path: '/Rccl.UserCenter/Suggestion/Index',
        name: 'Suggestion',
        component: () => import('@/views/UserCenter/Suggestion.vue')
    },
    {
        path: '/Rccl.Review/ReviewPicture/Index',
        name: 'ReviewIndex',
        component: () => import('@/views/Review/ReviewIndex.vue')
    },
    {
        path: '/Rccl.Review/ReviewPicture/Detail',
        name: 'ReviewDetail',
        component: () => import('@/views/Review/ReviewDetail.vue')
    },
    {
        path: '/Rccl.Review/ReviewPicture/OwnPicture',
        name: 'OwnPicture',
        component: () => import('@/views/Review/OwnPicture.vue')
    },
    {
        path: '/Rccl.Review/ReviewPicture/UploadPicture',
        name: 'UploadPicture',
        props: true,
        component: () => import('@/views/Review/UploadPicture.vue')
    },
    {
        path: '/Rccl.Review/ReviewPicture/NickName',
        name: 'NickName',
        component: () => import('@/views/Review/NickName.vue')
    },
    {
        path: '/Rccl.Review/Travel/OwnReview',
        name: 'OwnReview',
        component: () => import('@/views/Review/OwnReview.vue')
    },
    {
        path: '/Rccl.Review/Travel/TravelNotes',
        redirect: { name: "TravelNotes"}
    },
    {
        path: '/Rccl.Review/Travel/tn-n-n-0-0-9.html',
        name: 'TravelNotes',
        component: () => import('@/views/Review/TravelNotes.vue')
    },
    {
        path: '/Rccl.Review/Travel/d-:countryName-:shipName-:orderBy-:offset-:travelId.html',
        name: 'TravelNotesDetail',
        props: true,
        component: () => import('@/views/Review/TravelNoteDetail.vue')
    },
    {
        path: '/Rccl.Review/Travel/Guide',
        name: 'Guide',
        component: () => import('@/views/Review/Guide.vue')
    },
    {
        path: '/Rccl.CustomPage/RcclNews',
        name: 'RcclNewsIndex',
        component: () => import('@/views/CustomPage/RcclNewsIndex.vue')
    },
    {
        path: '/Rccl.CustomPage/RcclNews/Detail/:id.html',
        name: 'RcclNewsDetail',
        component: () => import('@/views/CustomPage/RcclNewsDetail.vue')
    },
    {
        path: '/Rccl.CustomPage/Country/CountryList',
        name: 'CountryList',
        component: () => import('@/views/CustomPage/CountryList.vue')
    },
    {
        path: '/Rccl.CustomPage/ShorexIntro/ShorexIntroList',
        name: 'ShorexIntroList',
        props: true,
        component: () => import('@/views/CustomPage/ShorexIntroList.vue')
    },
    {
        path: '/Rccl.UserCenter/CruiseWatch/*',
        name: 'CruiseWatch',
        component: () => import('@/views/UserCenter/CruiseWatch.vue')
    },
    {
        path: '/Rccl.Partner/Partner/*',
        name: 'Partner',
        component: () => import('@/views/Pages/Partner.vue')
    },
    {
        path: '/partner',
        redirect: '/Rccl.Partner/Partner/Index'
    },
    {
        path: '/Rccl.CustomPage/MediaCenter',
        component: MediaCenterLayout,
        redirect: '/Rccl.CustomPage/MediaCenter/Index',
        children: [{
            path: '/Rccl.CustomPage/MediaCenter/Index',
            name: 'Index',
            meta: {
                title: "媒体与新闻中心",
                isDownloadCenter: true
            },
            component: () => import('@/views/MediaCenter/Index.vue')
        },{
            path: '/Rccl.CustomPage/MediaCenter/MediaLogin',
            name: 'MediaLogin',
            meta: {
                title: "媒体与新闻中心",
                isDownloadCenter: true
            },
            component: () => import('@/views/MediaCenter/MediaLogin.vue')
        },{
            path: '/Rccl.CustomPage/MediaCenter/ManuscriptDownload',
            name: 'ManuscriptDownload',
            meta: {
                title: "文稿下载",
                isDownloadCenter: true
            },
            component: () => import('@/views/MediaCenter/ManuscriptDownload.vue')
        },{
            path: '/Rccl.CustomPage/MediaCenter/ImagesDownload',
            name: 'ImagesDownload',
            meta: {
                title: "图片下载",
                isDownloadCenter: true
            },
            component: () => import('@/views/MediaCenter/ImagesDownload.vue')
        },{
            path: '/Rccl.CustomPage/MediaCenter/VideosDownload',
            name: 'VideosDownload',
            meta: {
                title: "视频下载",
                isDownloadCenter: true
            },
            component: () => import('@/views/MediaCenter/VideosDownload.vue')
        },{
            path: '/Rccl.CustomPage/MediaCenter/AboutUs',
            name: 'AboutUs',
            meta: {
                title: "关于我们",
                isDownloadCenter: true
            },
            component: () => import('@/views/MediaCenter/AboutUs.vue')
        },{
            path: '/Rccl.CustomPage/MediaCenter/DownloadDetails/:id',
            name: 'DownloadDetails',
            meta: {
                title: "详情",
                isDownloadCenter: true
            },
            component: () => import('@/views/MediaCenter/DownloadDetails.vue')
        },{
            path: '/Rccl.CustomPage/questionnaire/SurveyQuestion',
            name: 'SurveyQuestion',
            component: () => import('@/views/SurveyQuestion/SurveyQuestion.vue')
        },
        ]
    },
    {
        path: '/shoppingmall/search',
        name: 'shoppingMallSearch',
        component: () => import('@/views/ShoppingMall/Search.vue')
    },
    {
        path: '/Rccl.Olci/Olci/CheckInIndex',
        name: 'CheckInIndex',
        component: () => import('@/views/Olci/CheckInIndex.vue')
    },
    {
        path: '/Rccl.Olci/Olci/MobileNewCheckIn',
        name: 'MobileNewCheckIn',
        component: () => import('@/views/Olci/MobileNewCheckIn.vue')
    },
    {
        path: '*',
        name: 'page-content',
        component: () => import('@/views/Pages/PageContent.vue')
    },
    {
        path: '/Rccl.Booking/Booking/InvoiceDetails',
        name: 'InvoiceDetails',
        component: () => import('@/views/Invoice/InvoiceDetails.vue')
    },
    {
        path: '/Rccl.Booking/Booking/InvoiceDetailsProgress',
        name: 'InvoiceDetailsProgress',
        component: () => import('@/views/Invoice/InvoiceDetailsProgress.vue')
    },
    {
        path: '/Rccl.CustomPage/Mice',
        name: 'Mice',
        component: () => import('@/views/Mice/Mice.vue')
    },
    {
        path: '/Rccl.Cruise/CruiseSearch/SearchRow',
        name: 'CruiseSearchRow',
        component: () => import('@/views/Cruise/SearchRow.vue')
    },
]
